import { IMAGES } from "@/lib/images";
import { PageHero, SectionHeading, CTABand } from "@/components/PageBlocks";
import { Reveal } from "@/components/Reveal";
import { useSeo } from "@/hooks/useSeo";
import { Link } from "react-router-dom";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";

const STYLES = [
  { img: IMAGES.dest1, name: "Beaches & Islands" },
  { img: IMAGES.resort, name: "Caribbean & Mexico" },
  { img: IMAGES.dest2, name: "Europe & Mediterranean" },
  { img: IMAGES.dest4, name: "Cities & Culture" },
  { img: IMAGES.expedition, name: "Adventure & Nature" },
  { img: IMAGES.cruise, name: "Cruises" },
  { img: IMAGES.honeymoon, name: "Romantic Escapes" },
  { img: IMAGES.dest3, name: "Group-Friendly Destinations" },
];

export default function Destinations() {
  useSeo({ title: "Destinations | Inforno Travel", description: "You don't need to know exactly where to go. Tell us the feeling you're after and we'll help explore where your passport could take you next." });
  return (
    <div className="bg-noir min-h-screen">
      <Navbar />
      <PageHero overline="Destinations" title="A World Worth Exploring." image={IMAGES.dest3}
        sub="Sometimes you know the destination. Sometimes you only know the feeling you're looking for. Tell us what you want from your trip and we'll help you explore where your passport could take you next."
        primary={{ label: "Explore Your Next Destination", to: "/start-your-journey" }} />

      <section className="py-24 md:py-32 px-6 md:px-12 bg-noir">
        <div className="max-w-[1500px] mx-auto">
          <div className="mb-14"><SectionHeading overline="Find Inspiration" title={<>Browse by the kind of trip<br /><span className="italic text-white/60">you're dreaming about.</span></>} /></div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
            {STYLES.map((s, i) => (
              <Reveal key={s.name} delay={(i % 4) * 0.08}>
                <Link to="/start-your-journey" data-testid={`dest-style-${i}`} className="group relative block overflow-hidden border border-white/10 aspect-[3/4]">
                  <img src={s.img} alt={s.name} loading="lazy" className="w-full h-full object-cover brightness-[0.65] group-hover:brightness-100 group-hover:scale-[1.06] transition-all duration-[1200ms] ease-out" />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-transparent to-transparent" />
                  <h3 className="absolute bottom-0 left-0 p-6 font-serif text-2xl font-light">{s.name}</h3>
                </Link>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <CTABand eyebrow="Not sure yet?" title="Where will your passport take you next?" label="Explore Your Next Destination" to="/start-your-journey" />
      <Footer />
    </div>
  );
}
